import { gql } from '@apollo/client'

export const TOURS_CAROUSEL_DATA = gql`
  query ToursCarouselData($ids: String) {
    allTours(ids: $ids) {
      edges {
        node {
          id
          title
          tourPhoto {
            extension
            path
          }
          slug
          artistFullName
        }
      }
    }
  }
`
export const GET_TOUR_BY_SLUG_EVENTS_PAGE = gql`
  query GetTourBySlugForListHeading($slug: String) {
    allTours(slug: $slug, status: "public") {
      edges {
        node {
          id
          title
          tourPhoto {
            id
            path
            extension
          }
          artistFullName
        }
      }
    }
  }
`
export const GET_TOUR_BY_SLUG_TOUR_PAGE = gql`
  query GetTourBySlug($slug: String) {
    allTours(slug: $slug, status_In: "public, private") {
      edges {
        node {
          id
          slug
          title
          status
          description
          tourPhoto {
            id
            path
            extension
          }
          artistSlug
          artistFullName
          featuringArtists {
            fullName
          }
        }
      }
    }
  }
`
export const LATEST_AND_GREATEST = gql`
  query LatestAndGreatest($eventStartDateGte: String) {
    allTours(featuredDate_Isnull: false, status: "public", orderBy: "-featured_date") {
      edges {
        node {
          id
          title
          tourPhoto {
            extension
            path
          }
          slug
          artistFullName
          artworks(eventStartDate_Gte: $eventStartDateGte) {
            id
          }
        }
      }
    }
  }
`
